/**
 *  Created by huangzhangshu by 2020/05/07
 *  捕获全局异常组件
 *  显示异常信息
 */

import React, { Component } from 'react';
import { Alert } from 'antd';

export interface ErrorBoundaryProps {
  message?: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
}

export interface ErrorBoundaryState {
  error?: Error | null;
  info: {
    componentStack?: string;
  }
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  readonly state: Readonly<ErrorBoundaryState> = {
    error: undefined,
    info: {
      componentStack: '',
    }
  }

  componentDidCatch(error: Error | null, info: object) {
    this.setState({ error, info })
  }

  render() {
    const { message, description, children } = this.props;
    const { error, info } = this.state;
    const componentStack = info && info.componentStack ? info.componentStack : null;
    const errorMessage = typeof message === 'undefined' ? (error || '').toString() : message;
    const errorDescription = typeof description === 'undefined' ? componentStack : description;
    if (error) {
      return <Alert type="error" message={errorMessage} description={errorDescription} />
    }
    // Normally, just render children
    return children;
  }
}
